import React from 'react';
import { Link } from 'react-router-dom'
import SubLayout from '../../components/Layout/SubLayout'
import strings from "../../components/Language";
import "./wallet.scss"
import _ from 'lodash';

import NoDataFound from './../../assets/images/icons/no_data_found.svg';

import walletdeposit from './../../assets/images/icons/wallet-deposit.webp';
import walletwithdraw from './../../assets/images/icons/wallet-withdraw.webp';
import wallettransfer from './../../assets/images/icons/wallet-transfer.webp';
import walletcoin from './../../assets/images/icons/wallet-coin.svg';
import { Button } from 'antd';
import { toast } from 'react-toastify';
import axios from 'axios';
import { api } from '../../components/config/api.js';
import { getToken, storeUserData, getUserData } from '../../components/Util';

import ListItem from '@mui/material/ListItem';
import LoaderContext from '../../components/Loader/LoaderContext.js';
import moment from 'moment';
import NativeDateField from '../../components/NativeDateField';
class WalletScreen extends React.Component {

	static contextType = LoaderContext;
	constructor(props) {
		super(props);
		this.state = {
			access_token: "",
			data: [],
			nextPageLink: "",
			prevPageLink: "",
			balance: 0,
			user_data: {},
			active_tab: "usdt",
			startDate: null,
			endDate: null,

		}
	}

	async componentDidMount() {
		var token = await getToken();
		if (token) {
			await storeUserData(token);
			this.setState({ access_token: token });
			setTimeout(() => {
				var user_data = getUserData();
				this.setState({ user_data: (user_data && user_data.data) ? user_data.data : {} });
				this.getData(api.usdt_history);
			});
		}
	}

	getData(API) {
		if (!API) {
			toast.error(strings.URI_not_found);
			return false;
		}
		var self = this;
		const { setLoading } = this.context;
		setLoading(true);
		axios({
			method: 'GET',
			url: API,
			headers: {
				'Authorization': 'Bearer ' + self.state.access_token,
				'Content-Type': 'application/json',
				'Accept-Language': strings.getLanguage()
			}
		}).then(function (ress) {

			if (ress.data.data && ress.data.data.length > 0) {
				self.setState({
					data: ress.data.data,
					nextPageLink: ress.data.links.next,
					prevPageLink: ress.data.links.prev,
					balance: ress.data.available_usdt
				});
			} else {
				if (ress.data.validation && ress.data.validation.length !== 0) {
					_.forEach(ress.data.validation, function (value) {
						if (value[0]) {
							toast.error(value[0]);
						}
					});
				} else {
					toast.error(ress.data.message);
				}
			}
			setLoading(false);
		}).catch(function (e) {
			setLoading(false);
		});
	};

	getNextData(API) {
		if (!API) {
			toast.error(strings.URI_not_found);
			return false;
		}
		var API_URL = API;
		if (this.state.startDate && this.state.endDate) {
			API_URL = API + "&start_date=" + (this.state.startDate ? moment(this.state.startDate).format("YYYY-MM-DD") : "") + "&end_date=" + (this.state.endDate ? moment(this.state.endDate).format("YYYY-MM-DD") : "");
		}
		var self = this;
		self.setState({
			nextPageLink: "",
			prevPageLink: "",
		});
		const { setLoading } = this.context;
		setLoading(true);
		axios({
			method: 'GET',
			url: API_URL,
			headers: {
				'Authorization': 'Bearer ' + self.state.access_token,
				'Content-Type': 'application/json',
				'Accept-Language': strings.getLanguage()
			}
		}).then(function (ress) {

			if (ress.data.data && ress.data.data.length > 0) {
				self.setState({
					data: [...self.state.data, ...ress.data.data],
					nextPageLink: ress.data.links.next,
					prevPageLink: ress.data.links.prev,
				});
			} else {
				if (ress.data.validation && ress.data.validation.length !== 0) {
					_.forEach(ress.data.validation, function (value) {
						if (value[0]) {
							toast.error(value[0]);
						}
					});
				} else {
					toast.error(ress.data.message);
				}
			}
			setLoading(false);
		}).catch(function (e) {
			toast.error(e.message);
			setLoading(false);
		});
	};

	handleNativeRange = (which, value) => {
		const key = which === 'start' ? 'startDate' : 'endDate';
		this.setState({ [key]: value || null }, () => {
			const { startDate, endDate } = this.state;
			if (this.props.onChange) {
				this.props.onChange({ startDate, endDate });
			}
			if (startDate && endDate) {
				const sd = moment(startDate).format('YYYY-MM-DD');
				const ed = moment(endDate).format('YYYY-MM-DD');
				this.getData(`${api.usdt_history}?start_date=${sd}&end_date=${ed}`);
			} else if (!startDate && !endDate) {
				this.getData(api.usdt_history);
			}
		});
	};


	render() {
		const { startDate, endDate } = this.state;
		const actionCards = [
			{ to: '/deposit', image: walletdeposit, title: strings.deposit, desc: 'Top up your trading balance' },
			{ to: '/transfer', image: wallettransfer, title: strings.transfer, desc: 'Move funds across accounts' },
			{ to: '/withdrawal', image: walletwithdraw, title: strings.withdraw, desc: 'Send assets to your wallet' }
		];
		const showFuelAlert = (
			this.state.user_data
			&& (this.state.user_data.credit && this.state.user_data.credit.usdt >= 2 && this.state.user_data.credit.usdt < 10)
			&& (this.state.user_data.status_data && this.state.user_data.status_data.identifier === "active")
		);

		return (
			<SubLayout data={{ "title": strings.wallet }}>
				<div className="wallet-page">
					<div className="wallet-shell">
						<section className="wallet-hero">
							<div className="wallet-hero-top">
								<div>
									<div className="wallet-badge">{strings.wallet}</div>
									<div className="wallet-balance-label">{strings.usdt_balance}</div>
									<div className="wallet-balance-value">{this.state.balance.toFixed(8)}</div>
									<div className="wallet-balance-sub">= {this.state.balance.toFixed(8)} {strings.usdt}</div>
								</div>
								<img src={walletcoin} alt="Wallet" className="wallet-hero-icon"></img>
							</div>
							<div className="wallet-actions">
								{actionCards.map((item) => (
									<Link key={item.to} to={item.to} className='wallet-action-card'>
										<img src={item.image} alt={item.title}></img>
										<strong>{item.title}</strong>
										<span>{item.desc}</span>
									</Link>
								))}
							</div>
						</section>

						{showFuelAlert ?
							<div className='wallet-alert'>{strings.fuel_balance_is_insufficient}</div>
							: null}

						<section className='wallet-section'>
							<div className='wallet-section-head'>
								<div>
									<h3>{strings.history_record}</h3>
									<p>Track deposits, withdrawals and wallet activity in one place.</p>
								</div>
							</div>

							<div className='wallet-filter'>
								<div className='date-range-native'>
									<div className='drn-field'>
										<label className='drn-label'>{strings.from_date}</label>
										<NativeDateField value={startDate || ''} max={endDate || undefined}
											onChange={(e) => this.handleNativeRange('start', e.target.value)} />
									</div>
									<div className='drn-field'>
										<label className='drn-label'>{strings.to_date}</label>
										<NativeDateField value={endDate || ''} min={startDate || undefined}
											onChange={(e) => this.handleNativeRange('end', e.target.value)} />
									</div>
								</div>
							</div>

							<div style={{ marginTop: 16 }}>
								{this.state.data && this.state.data.length > 0 ?
									<>
										<div className='wallet-history-list'>
											{
												this.state.data.map((item, i) =>
													<ListItem disablePadding key={i}>
														<Link to={{
															data: item,
															params: item.id
														}} params={{ data: item }} className='wallet-history-link'>
															<div className='wallet-history-card'>
																<div className='wallet-history-top'>
																	<div className='wallet-history-amount'>
																		<strong className={Number(item.amount) < 0 ? 'wallet-amount-negative' : 'wallet-amount-positive'}>
																			{item.amount.toFixed(8)}
																		</strong>
																	</div>
																	<div className='wallet-history-time'>
																		{item.created_at_ ? moment(item.created_at).format("YYYY/MM/DD HH:mm:ssA") : '-'}
																	</div>
																</div>
																<div className='wallet-history-desc'>{item.description}</div>
															</div>
														</Link>
													</ListItem>
												)
											}
										</div>
										{this.state.nextPageLink ?
											<div className='wallet-loadmore'>
												<Button onClick={() => this.getNextData(this.state.nextPageLink)} type="primary">
													{strings.Load_More}
												</Button>
											</div>
											: null}
									</>
									: <div className='wallet-empty'>
										<img src={NoDataFound} alt="CTS Bot"></img>
									</div>}
							</div>
						</section>
					</div>
				</div>
			</SubLayout >
		);
	}
}

export default WalletScreen;
